import React from 'react'
import styles from './button.module.scss'
import classnames from 'classnames'
import Loader from '../Loader'

const Button = (props) =>
{
    const { title, onClick, className, type, isLoading, bigger, smaller, white, disabled } = props
    
    let isDisabled = isLoading || disabled
    
    return (
        <button
            type={type ? type : "button"}
            className={classnames(styles.button, className, {
                                                                [styles.bigger]: bigger,
                                                                [styles.smaller]: smaller,
                                                                [styles.white]: white,
                                                                [styles.disabled]: isDisabled
                                                            })}
            onClick={onClick}
            disabled={isDisabled}
        >
            {
                isLoading &&
                <Loader
                    isLoading
                    spinner
                    primary={false}
                    white={!white}
                    gray={white}
                    className={styles.loader}
                />
            }
            <div>{ title }</div>
        </button>
    )
}

export default Button
